import { render, staticRenderFns } from "./MemberExtSubaccountConfig.vue?vue&type=template&id=04efadd6&scoped=true&"
import script from "./MemberExtSubaccountConfig.vue?vue&type=script&lang=js&"
export * from "./MemberExtSubaccountConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efadd6",
  null
  
)

component.options.__file = "MemberExtSubaccountConfig.vue"
export default component.exports